import { BaseResponseBase } from "abweb/dto/generated/genericResponse/BaseResponseBase";
export class BaseResponse extends BaseResponseBase {
  // This generated tsog class would ideally be generic (BaseResponse<PayloadT>) but tsog doesn't support that.
  // Instead, force subclass to use stronger (narrowed) type than the native payload 'any'.  Each subclass should:
  // 1. override get/set with narrowed type (replace 'any' in signature with desired type)
  // 2. change static createFoo factory method signature to take payload: DesiredType arg instead of payload: any
  // 3. If the desired type needs to be decoded (isn't a native json data structure), then override initJson so that
  //    the payload is decoded properly (typically via TSOGUtils.decodeObject,
  //    but could be other data structs as well (arrays, maps)
  // See LwParseResponse as an nice example of a BaseResponse child class.

  // The get/set below are abstract simply to force the child class to implement them (with narrowed type)
  // Note child class overrides of get/set that call 'super.payload' will correctly
  // access the BaseResponseBase getter/setter, as the abstract definitions in this file aren't present in emitted js.

  // Below are needed so that payload overrides of the abstract method above can access the BaseResponseBase.payload
  // member variable (can't use 'super.payload' as tsc complains that it is an abstract prop, so use 'super.payloadAny' instead)
  get payloadAny() {
    return super.payload;
  }
  set payloadAny(value) {
    super.payload = value;
  }
}
//# sourceMappingURL=BaseResponse.js.map
